<template>
  <LoginPanel />
</template>
